import { render, staticRenderFns } from "./CRFRadioGroup.vue?vue&type=template&id=a3cfedb6&"
import script from "./CRFRadioGroup.vue?vue&type=script&lang=js&"
export * from "./CRFRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./CRFRadioGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports